import { GameConstants } from "../../../GameConstants";
import { Button } from "../../../utils/Button";
import { GameVars } from "../../../GameVars";
import { AudioButtonContainer } from "../../AudioButtonContainer";
import { ButtonWithText } from "../../../utils/ButtonWithText";
import { GameManager } from "../../../GameManager";
import { BoardScene } from "../BoardScene";
import { AudioManager } from "../../../AudioManager";
import { BootScene } from "../../BootScene";

export class PauseLayer extends Phaser.GameObjects.Container {

    private menu1Container: Phaser.GameObjects.Container;
    private menu2Container: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x132A4B, .35);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(background);

        this.menu1Container = new Phaser.GameObjects.Container(this.scene);
        this.menu1Container.x = GameConstants.GAME_WIDTH / 2;
        this.menu1Container.y = GameConstants.GAME_HEIGHT / 2;
        this.menu1Container.scaleY = GameVars.scaleY;
        this.add(this.menu1Container);

        let width = 390;
        let height = 320;

        let menuBackground = new Phaser.GameObjects.Graphics(this.scene);
        menuBackground.fillStyle(0x132A4B, .85);
        menuBackground.fillRoundedRect(-width / 2, -height / 2, width, height, 10);
        this.menu1Container.add(menuBackground);

        const closeButton = new Button(this.scene, 190, -158, "texture_atlas_1", "btn_close_off", "btn_close_on");
        closeButton.setScale(0);
        closeButton.onDown(this.onClickClose, this);
        this.menu1Container.add(closeButton);

        this.scene.tweens.add({
            targets: closeButton,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Elastic.Out,
            duration: 350,
            delay: 350
        });

        const audioButton = new AudioButtonContainer(this.scene);
        audioButton.y = -30;
        this.menu1Container.add(audioButton);

        const gameText = this.scene.game.cache.json.get("game-text");

        const quitButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_orange");
        const quitButtonText = new Phaser.GameObjects.Text(this.scene, 0, -5 + (BootScene.textYgap * -80), gameText.QUIT, { fontFamily: "Teko-Medium", fontSize: "60px", color: "#FFFFFF" });
        quitButtonText.setOrigin(.5,BootScene.originY);
        quitButtonText.setShadow(0, 5, "#BA400E", 0, false, true);
        this.add(quitButtonText);

        const quitButton = new ButtonWithText(this.scene, quitButtonImage, quitButtonText, this.onQuitClick, this);
        quitButton.y = 150;
        this.menu1Container.add(quitButton);

        this.menu2Container = new Phaser.GameObjects.Container(this.scene);
        this.menu2Container.x = GameConstants.GAME_WIDTH / 2;
        this.menu2Container.y = GameConstants.GAME_HEIGHT / 2;
        this.menu2Container.scaleY = GameVars.scaleY;
        this.add(this.menu2Container);

        menuBackground = new Phaser.GameObjects.Graphics(this.scene);
        menuBackground.fillStyle(0x132A4B, .85);
        menuBackground.fillRoundedRect(-width / 2, -height / 2, width, height, 10);
        this.menu2Container.add(menuBackground);

        const quitText = new Phaser.GameObjects.Text(this.scene, 0, -115 + (BootScene.textYgap * -72), gameText.QUIT_GAME, { fontFamily: "Teko-Medium", fontSize: "48px", color: "#FFFFFF" });
        quitText.setOrigin(.5,BootScene.originY);
        quitText.setShadow(0, 4, "#132A4B", 0, false, true);
        this.menu2Container.add(quitText);

        width = 340;
        height = 160;

        menuBackground = new Phaser.GameObjects.Graphics(this.scene);
        menuBackground.fillStyle(0x132A4B);
        menuBackground.fillRoundedRect(-width / 2, -height / 2 + 10, width, height, 10);
        this.menu2Container.add(menuBackground);

        const quitDescriptionText = new Phaser.GameObjects.Text(this.scene, 0, 5 + (BootScene.textYgap * -40), gameText.QUIT_INFO, { fontFamily: "Wolf-Sans-Regular", align: "center", fontSize: "24px", color: "#FFFFFF" });
        quitDescriptionText.setOrigin(.5,BootScene.originY);
        if(BootScene._isBrave) quitDescriptionText.setLineSpacing(20 + (BootScene.textYgap * -270));
        this.menu2Container.add(quitDescriptionText);

        const yesButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_orange");
        const yesButtonText = new Phaser.GameObjects.Text(this.scene, 0, -5 + (BootScene.textYgap * -80), gameText.YES, { fontFamily: "Teko-Medium", fontSize: "60px", color: "#FFFFFF" });
        yesButtonText.setOrigin(.5,BootScene.originY);
        yesButtonText.setShadow(0, 5, "#BA400E", 0, false, true);
        this.add(yesButtonText);

        const yesButton = new ButtonWithText(this.scene, yesButtonImage, yesButtonText, this.onYesClick, this);
        yesButton.x = -100;
        yesButton.y = 150;
        yesButton.setScale(.7);
        this.menu2Container.add(yesButton);

        const noButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_green");
        const noButtonText = new Phaser.GameObjects.Text(this.scene, 0, -5 + (BootScene.textYgap * -80), gameText.NO, { fontFamily: "Teko-Medium", fontSize: "60px", color: "#FFFFFF" });
        noButtonText.setOrigin(.5,BootScene.originY);
        noButtonText.setShadow(0, 5, "#46902f", 0, false, true);
        this.add(noButtonText);

        const noButton = new ButtonWithText(this.scene, noButtonImage, noButtonText, this.onNoClick, this);
        noButton.x = 100;
        noButton.y = 150;
        noButton.setScale(.7);
        this.menu2Container.add(noButton);

        this.menu2Container.visible = false;

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
    }

    private onYesClick(): void {

        AudioManager.playSound("click_btn");

        GameManager.quitMatch();
    }

    private onNoClick(): void {

        AudioManager.playSound("click_btn");

        const boardManager = BoardScene.currentInstance.boardManager;
        boardManager.hideMenu();
    }

    private onQuitClick(): void {

        AudioManager.playSound("click_btn");

        this.menu1Container.visible = false;
        this.menu2Container.visible = true;
    }

    private onClickClose(): void {

        AudioManager.playSound("click_btn");

        const boardManager = BoardScene.currentInstance.boardManager;
        boardManager.hideMenu();
    }
}
